var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-module-herolaurel"},[_c('a',{attrs:{"href":"https://opencritic.com/browse/pc/2023","target":"_blank"}},[_c('img',{attrs:{"src":require("@/Asset/image/graphic/laurels-big.webp"),"alt":"Open Critic - 90% - #9 PC Game of 2023"}})])])
}]

export { render, staticRenderFns }